import { CiLock, CiUnlock } from "react-icons/ci";

export const SYSTEM_ACCESS = ["amnIbEVWkPUysFt3Kjmr", "rkXsYv8H41SHOM9ZAoky"];

export const USER_GROUPS = [
  {
    name: "Administrator",
    value: "Administrator",
    permissions: ["p0", "c1", "c2", "t1", "n1"],
  },
  {
    name: "Quản trị viên",
    value: "Operator",
    permissions: ["c1"],
  },
];

export const FULL_PERMISSION = ["p0", "c1", "c2", "t1", "n1"];

export const PERMISSION = {
  OPERATOR: "p0",
  CONCEPT: "c1",
  APPROVE: "c2",
  THREE: "t1",
  NEWS: "n1",
};

export const SUB_PERMISSION = {};

export const PERMISSIONS = [
  { id: PERMISSION.OPERATOR, name: "Quản lý quản trị viên" },
  { id: PERMISSION.CONCEPT, name: "Quản lý ý tưởng" },
  { id: PERMISSION.APPROVE, name: "Quản lý xét duyệt" },
  { id: PERMISSION.THREE, name: "Quản lý mô hình 3D" },
  { id: PERMISSION.NEWS, name: "Quản lý tin tức" },
];

export const PERMISSIONS_SUB = [];

export const TIMESTAMP = "DD/MM/YYYY HH:mm:ss";

export const CATEGORIES_SOURCE = [
  {
    label: "VDI GROUP",
    value: "vdigroup",
  },
];

const size = 20;
const color = "black";
export const STATUS_DOCUMENT = [
  {
    value: true,
    label: "Đang khoá",
    icon: <CiLock color={color} size={size} />,
  },
  {
    value: false,
    label: "Có thể tải",
    icon: <CiUnlock color={color} size={size} />,
  },
];

/// ====== COLORS SPEAKER ======== //
export const COLORS_SPEAKER = [
  "#E1EDF5",
  "#DBEAE1",
  "#edc2cf",
  "#edecc2",
  "#cbc2ed",
];

/// ====== JOB STATUS ======== //

export const JOB_STATUS = [
  {
    value: "waiting",
    label: "Đặt cọc",
    color: "orange",
  },
  {
    value: "waiting for deposit",
    label: "Đặt cọc",
    color: "orange",
  },
  {
    value: "transcript",
    label: "AI biên dịch",
    color: "blue",
  },
  {
    value: "suppoter",
    label: "AI sửa lỗi",
    color: "purple",
  },
  {
    value: "approval",
    label: "Hoàn tất",
    color: "green",
  },
];

// =============
export const SUPPORTER_PERMISSIONS = [
  {
    label: "Nhận Nhiệm vụ từ Dịch Vụ Chuyển Âm",
    value: "tl",
  },
  {
    label: "Nhận Nhiệm vụ từ sách sống",
    value: "yo",
  },
];

// STATUS PAYMENT.
export const STATUS_PAYMENT = [
  {
    label: "Tạm giữ",
    value: "waiting",
    color: "orange",
  },
  {
    label: "Kiểm tra",
    value: "verifing",
    color: "blue",
  },

  {
    label: "Đã duyệt",
    value: "verified",
    color: "green",
  },
  {
    label: "Bị huỷ",
    value: "deny",
    color: "red",
  },
];

// STATUS WITHDRAW
export const STATUS_WITHDRAW = [
  {
    label: "Đang chờ duyệt",
    value: "waiting",
    color: "orange",
  },
  {
    label: "Đã trả",
    value: "paid",
    color: "green",
  },
];
